import { render } from "./AddDomain.vue?vue&type=template&id=25e9b301&ts=true"
import script from "./AddDomain.vue?vue&type=script&lang=ts"
export * from "./AddDomain.vue?vue&type=script&lang=ts"

import "./AddDomain.vue?vue&type=style&index=0&id=25e9b301&lang=scss"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QField});
